<template>
  <div class="horizontal-menu-wrapper">

    <div
        class="header-navbar navbar-expand-sm navbar navbar-horizontal floating-nav navbar-light navbar-without-dd-arrow navbar-shadow menu-border"
        role="navigation" data-menu="menu-wrapper">

      <!-- Horizontal menu content-->
      <div class="navbar-container main-menu-content" data-menu="menu-container">
        <ul class="nav navbar-nav float-left main-menu-navigation" data-menu="menu-navigation">
          <!--					<li class="nav-item  ">-->
          <!--						<a class="nav-link nav-menu-main menu-toggle hidden-xs" to="" href="#">-->
          <!--							<i class="ficon feather icon-menu"></i>-->
          <!--						</a>-->
          <!--					</li>-->
          <li class="nav-item">
            <router-link :to="{'name':'dashboard'}" class="nav-link">
              <i class="feather icon-bar-chart-2"></i>
              <span class=" d-md-inline-block d-none">
                {{ lexicon.drop_stat_title }}
							</span>

            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{'name':'orders'}" class="nav-link">
              <i class="feather icon-shopping-cart"></i>
              <span class=" d-md-inline-block d-none">
                {{ lexicon.drop_orders }}
							</span>

            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{'name':'order', hash: '#products'}" class="nav-link">
              <i class="feather icon-plus-circle"></i>
              <span class=" d-md-inline-block d-none">
								{{ lexicon.drop_products }}
							</span>

            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{'name':'payments'}" class="nav-link">
              <i class="feather icon-git-merge"></i>
              <span class=" d-md-inline-block d-none">
                {{ lexicon.drop_payments }}
							</span>

            </router-link>
          </li>
        </ul>
        <ul class="nav navbar-nav float-right main-menu-navigation" v-if="authenticated">


          <li class="nav-item" v-if="user.settings.showSale">
            <a class="nav-link blob red " @click="getBrn(true)">
              <i class="feather icon-percent m-0"></i>
            </a>
          </li>
          <template v-if="user.id===10">
            <li class="nav-item">  <!--   v-if="user.admin"-->
              <router-link :to="{'name':'support'}" class="nav-link">
                <i class="feather icon-life-buoy"></i>
                <span class=" d-md-inline-block d-none"> 	{{ lexicon.drop_support }}  </span>
              </router-link>
            </li>
            <li class="nav-item"> <!--   v-else -->
              <a href="#" class="nav-link" @click.prevent="showChat = !showChat">
                <i class="feather icon-message-square"></i>
                <span class=" d-md-inline-block d-none"> 	{{ lexicon.drop_support }} user </span>
              </a>
            </li>
          </template>

          <li class="nav-item">
            <router-link :to="{'name':'settings'}" class="nav-link">
              <i class="feather icon-settings"></i>
              <span class=" d-md-inline-block d-none"> 	{{ lexicon.drop_settings }} </span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{'name':'payment'}" class="nav-link">
              {{ user.balance }} {{ lexicon[user.currency] }}
              <!--              <span class="d-md-inline-block  d-none">-->
              <!--								<small class="ml-25 mt-25 text-muted"> [ <em>{{ user.usd }} {{lexicon.drop_uah_sign}}</em> ]</small>-->
              <!--							</span>-->
            </router-link>
          </li>
          <li class=" nav-item">
            <a href="#" @click.prevent="Logout" class="nav-link">
              <i class="feather icon-log-out mr-1"></i>
              <span class=" d-md-inline-block d-none">{{ lexicon.drop_logout }}</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- /horizontal menu content-->
    </div>

    <!--
    <div>

          <ul>

            <li>
              <router-link :to="{'name':'home'}" exact>
                Home
              </router-link>
            </li>

            <li>
              <router-link :to="{'name':'login'}">
                Login
              </router-link>
            </li>
            <template v-if="authenticated">
              <li>
                {{ user.balance }}
              </li>
              <li>
                <router-link :to="{'name':'dashboard'}">
                  Dashboard
                </router-link>
              </li>
              <li>
                <router-link :to="{'name':'dashboard2'}">
                  Dashboard 2
                </router-link>
              </li>
              <li>
                <a href="#" @click.prevent="Logout">Logout</a>
              </li>
            </template>

            <template v-if="authenticated">
              <ul>
                <li v-for="notification in user.notifications" :key="notification">
                  {{notification}}
                </li>
              </ul>
            </template>
          </ul>
        </div>
    -->
    <div class="chat_area " :class="{'opened': showChat}">
      <div class="chat-box">
        <div class="header">
          <span class="name ml-0">Підтримка</span>
          <span class="options" @click="showChat = false">
            <i class="feather icon-x"></i>
          </span>
        </div>
        <div class="chat-room">
          <div class="message message-left">
            <div class="avatar-wrapper avatar-small">
                BRUSHME
            </div>
            <div class="bubble bubble-light">
              Hey anhat!
            </div>
          </div>
          <div class="message message-right">
            <div class="avatar-wrapper avatar-small">
             Ви
            </div>
            <div class="bubble bubble-dark">
              what is going on?
            </div>
          </div>
        </div>
        <div class="type-area">
          <div class="input-wrapper">
            <input type="text" id="inputText" placeholder="Type messages here..."/>
          </div>
          <span class="button-add">
      <i class="fas fa-plus-circle"></i>
      <div class="others">
        <span class="emoji-button">
          <i class="far fa-laugh"></i>
          <div class="emoji-box">
            <span>&#x1f604;</span>
            <span>😀</span>
            <span>😂</span>
            <span>😭</span>
            <span>😍</span>
            <span>🤮</span>
            <span>🤑</span>
            <span>😖</span>
            <span>😷</span>
          </div>
        </span>
        <span class="image-button">
          <i class="far fa-image"></i>
        </span>
        <span>
          <i class="fas fa-paperclip"></i>
        </span>
      </div>
    </span>
          <button class="button-send">Send</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

export default {

  data() {
    return {
      showChat: false,
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  methods: {
    ...mapActions({
      LogoutAction: 'auth/Logout',
      getBrn: 'auth/bnr'
    }),
    Logout() {
      this.LogoutAction().then(() => {
        this.$router.replace({
          name: 'login'
        })
      })
    }
  }
}
</script>

<style>
.blob.red {
  background: rgba(255, 82, 82, 1);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: pulse-red 2s infinite;
  color: white !important;
  border-radius: 3px;
}

.blob.red:hover {
  color: rgba(255, 82, 82, 1) !important;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
</style>